import { Grid, Box } from '@cad-arc';
import { observer } from 'mobx-react-lite';
import Skeleton from 'react-loading-skeleton';
import { useQueueStore } from '../context/use-queue-store';
import { colors } from '../../colors/colors';

export const LoadingQueueRow = observer(function LoadingQueueRow(): React.ReactElement {
    const store = useQueueStore();
    return (
        <Grid
            position="relative"
            borderBottom="1px solid"
            borderColor="border.default"
            templateColumns="var(--columns)"
        >
            {store.workspacePanel.queue.queueColumns.map((column, columnName) => (
                <Box key={columnName} className="base-queue-cell" px="2">
                    <Skeleton
                        baseColor={colors.skeletonBaseColor}
                        highlightColor={colors.skeletonHighlightColor}
                    />
                </Box>
            ))}
        </Grid>
    );
});
